import CandidateDetails from "pages/PanelPage/components/selectedAssessment/assessmentResults/takerResults/CandidateDetails/CandidateDetails";

export default CandidateDetails;
